// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de los botones del tragamonedas
 * @param {*} scene
 */
export function cargaAssetsBotones(scene) {
  // Assets boton subir apuesta
  scene.load.image(
    "botonSubirApuestaEstatico",
    ROUTES.rutaTragamonedasBotones + "/boton1SubirApuestaEstaticoResized.png"
  );
  scene.load.image(
    "botonSubirApuestaHover",
    ROUTES.rutaTragamonedasBotones + "/boton1SubirApuestaHoverResized.png"
  );
  scene.load.image(
    "botonSubirApuestaPressed",
    ROUTES.rutaTragamonedasBotones + "/boton1SubirApuestaPressedResized.png"
  );
  scene.load.image(
    "botonSubirApuestaDesactivado",
    ROUTES.rutaTragamonedasBotones + "/boton1SubirApuestaDesactivadoResized.png"
  );

  // Assets boton bajar apuesta
  scene.load.image(
    "botonBajarApuestaEstatico",
    ROUTES.rutaTragamonedasBotones + "/boton2BajarApuestaEstaticoResized.png"
  );
  scene.load.image(
    "botonBajarApuestaHover",
    ROUTES.rutaTragamonedasBotones + "/boton2BajarApuestaHoverResized.png"
  );
  scene.load.image(
    "botonBajarApuestaPressed",
    ROUTES.rutaTragamonedasBotones + "/boton2BajarApuestaPressedResized.png"
  );
  scene.load.image(
    "botonBajarApuestaDesactivado",
    ROUTES.rutaTragamonedasBotones + "/boton2BajarApuestaDesactivadoResized.png"
  );

  // Assets boton jugar apuesta
  scene.load.image(
    "botonJugarApuestaEstatico",
    ROUTES.rutaTragamonedasBotones + "/boton3JugarApuestaEstaticoResized.png"
  );
  scene.load.image(
    "botonJugarApuestaHover",
    ROUTES.rutaTragamonedasBotones + "/boton3JugarApuestaHoverResized.png"
  );
  scene.load.image(
    "botonJugarApuestaPressed",
    ROUTES.rutaTragamonedasBotones + "/boton3JugarApuestaPressedResized.png"
  );
  scene.load.image(
    "botonJugarApuestaDesactivado",
    ROUTES.rutaTragamonedasBotones + "/boton3JugarApuestaDesactivadoResized.png"
  );
}
